import { get, mergeDeep } from '../util';
import { getJWT } from '../redux/authentication/utils';
import { useSafeReducer } from './useSafeReducer';
import { CONTENT_TYPE_HEADER, CONTENT_TYPES } from '../constants/http';

const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

const initialState = {
    pending: false,
    error: false,
    data: null,
    success: false,
};

const reducer = (state, action) => {
    switch (action.type) {
        case REQUEST:
            return {
                error: false,
                pending: true,
                data: null,
                success: false,
            };
        case SUCCESS:
            return {
                error: false,
                pending: false,
                success: true,
                data: action.payload,
            };
        case FAILURE:
            return {
                error: true,
                pending: false,
                success: false,
                data: action.payload,
            };
        default:
            return state;
    }
};

const getPayloadByContentType = async (response, contentType) => {
    if (contentType === CONTENT_TYPES.PDF) {
        return response.blob();
    }

    return response.json();
};

const cacheData = {};

export const useBffApi = ({ path, options, cache = false }) => {
    const contentType = get(options, `headers[${CONTENT_TYPE_HEADER}]`);
    const defaultOptions = {
        headers: {
            'X-Frontend-Version': process.env.FRONTEND_VERSION_HASH || '',
            'X-Frontend-Build-Time': process.env.FRONTEND_BUILD_TIMESTAMP || '',
            Authorization: getJWT(),
            Publisher: CONFIG.myPage.publication,
            ...(['POST', 'PUT'].includes(options.method) ? { [CONTENT_TYPE_HEADER]: CONTENT_TYPES.JSON } : {}),
        },
    };

    const [{ error, pending, success, data }, dispatch] = useSafeReducer(reducer, initialState);

    const makeBffRequest = async (body) => {
        if (cache && cacheData[path] !== undefined) {
            dispatch({ type: SUCCESS, payload: cacheData[path] });
        } else {
            dispatch({ type: REQUEST });
            try {
                const host = CONFIG.myPage.apiHost;
                const response = await fetch(`${host}${path}`, mergeDeep({ body }, options, defaultOptions));
                if (!response.ok) {
                    throw response;
                }

                const payload =
                    response.status === 201 ? undefined : await getPayloadByContentType(response, contentType);

                if (cache) {
                    cacheData[path] = payload;
                }

                dispatch({
                    type: SUCCESS,
                    payload,
                });
            } catch (err) {
                dispatch({ type: FAILURE, payload: err.json ? await err.json() : err.message });
            }
        }
    };

    return [{ error, pending, success, data }, makeBffRequest];
};

export default useBffApi;
